// Bootsrap
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import React, {useRef} from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';

function ContactForm() {

  const ConctactForm = useRef();
  
  
    const SendEmail = (e) => {
      e.preventDefault();
   
      const {name, email, message, mobile } = ConctactForm.current.elements;
  
      emailjs.sendForm('service_a8sq73e', 'template_7000lft', ConctactForm.current,  'tJeEVtt8l6_rEiFHT')
        .then((result) => {
            toast.success("Hi Your Message Successfully! Our team will contact you soon.");
            console.log(result.text)
        }, (error) => {
       
            toast.error("Some technical error occurred. Please try again after sometime / contact@saintes.in ");
            console.log(error)
        });
    };
    return (

        <div className="contact-form w-100 d-inline-flex px-lg-5 py-lg-5">
        <Col sm={12} md={6} className='float-start d-inline-flex'>
        <ToastContainer/>
           <div className="w-100 text-lg-start pe-5">
                 <h6 className='fs-1 text-white fw-bold Gilroy-Heavy'>
                     GET IN TOUCH WITH US
                </h6>
                <p className='text-white fs-5 pt-md-1 border-bottom pb-md-3'>
                     For inquiries, partnerships, or to discuss your project requirements, please feel to contact us
                </p>
                <h6 className='fs-4 text-white fw-bold Gilroy-Heavy mt-3'>
                   Pouring Pints Pvt. Ltd.
                </h6>
                <p className='text-white fs-5 pt-md-2'>
                 <span className='col-auto d-sm-inline-flex pe-2 align-items-center justify-content-center h-25'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pin-map-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8z"/>
                        <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"/>
                    </svg> 
                </span> 
                <span className='col-lg-11 d-sm-inline-flex'>114/1,22nd cross, 30th main, B.S.K. 2nd stage,Opp. KIMS college, Bangalore-560070 </span>
                                    
                </p>
                <p className='text-white fs-5 pt-md-2'>
                <span className='col-auto d-sm-inline-flex pe-2'>    
                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
                        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                    </svg>
                </span>     
                <span className='col-lg-11 d-sm-inline-flex'> +91-998 658 9309 / +91 990 185 5334 </span>
                </p>
                <p className='text-white fs-5 pt-md-2'>
                <span className='col-auto d-sm-inline-flex pe-2'>    
                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-at" viewBox="0 0 16 16">
                        <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z"/>
                        <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"/>
                    </svg>  
                </span>     
                <span className='col-lg-11 d-sm-inline-flex'> pints.kv@gmail.com / pints.jj@gmail.com </span>
                </p>
           </div>
        </Col>

        <Col sm={12} md={6}>
        <Form ref={ConctactForm}  onSubmit={SendEmail}>
        <Form.Group className="mb-3">
        <Form.Label className='float-start text-white'>Name</Form.Label>
        <Form.Control type="text" name='name' placeholder="Enter Your Name" required/>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className='float-start text-white'>Email address</Form.Label>
        <Form.Control type="email" name='email' placeholder="name@example.com" required/>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className='float-start text-white'>Mobile Number</Form.Label>
        <Form.Control type="mobile" name='mobile' placeholder="96XXXXXXXX" required/>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className='float-start text-white'>Message</Form.Label>
        <Form.Control as="textarea" name='message' rows={3} placeholder='Hello....' required/>
      </Form.Group>
      <Button variant="light" type='submit' className='float-start'>Submit</Button>
    </Form>
        </Col>
     </div>
    )}

    export default ContactForm;       